var React = require('react');

function Discovery (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 1 10 C 1 12.21 1.9100000000000001 14.2 3.36 15.64 L 1 18 L 7 18 L 7 12 L 4.76 14.24 C 1.637 11.124 2.839 5.816 7 4.35 L 7 2.26 C 3.55 3.15 1 6.27 1 10 Z M 19 2 L 13 2 L 13 8 L 15.24 5.76 C 18.363 8.876 17.161 14.184 13 15.65 L 13 17.74 C 16.45 16.85 19 13.73 19 10 C 19 7.79 18.09 5.8 16.64 4.36 L 19 2 Z","fill":"currentColor","fillRule":"evenodd"}));
}

Discovery.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Discovery;

Discovery.default = Discovery;
